import React from 'react'
import MyProfileComponent from '../../../components/MyProfile/MyProfile.jsx'
export const MyProfile = () => {
  return <MyProfileComponent />
}
